import React from "react";

const PIECES = [
  { x:  4, shape: "rect",  fill: "#FF2D95", size: 1.8, delay: -0.5, dur: 6,   sway: 3, spin:  1 },
  { x: 10, shape: "tri",   fill: "#FFEE00", size: 1.5, delay: -2,   dur: 7,   sway: 5, spin: -1 },
  { x: 16, shape: "circ",  fill: "#3EB567", size: 1.2, delay: -1,   dur: 5,   sway: 2, spin:  1 },
  { x: 22, shape: "rect",  fill: "#00E5FF", size: 2.0, delay: -3,   dur: 8,   sway: 6, spin:  1 },
  { x: 28, shape: "strip", fill: "#FF8F47", size: 1.4, delay: -0.3, dur: 9,   sway: 4, spin: -1 },
  { x: 34, shape: "tri",   fill: "#FF4D7E", size: 1.3, delay: -1.7, dur: 6.5, sway: 3, spin:  1 },
  { x: 40, shape: "circ",  fill: "#8B5CF6", size: 1.0, delay: -2.5, dur: 5.5, sway: 5, spin: -1 },
  { x: 46, shape: "rect",  fill: "#FFEE00", size: 1.6, delay: -0.8, dur: 7.5, sway: 2, spin:  1 },
  { x: 52, shape: "strip", fill: "#FFFFFF", size: 1.5, delay: -3.5, dur: 10,  sway: 4, spin: -1 },
  { x: 58, shape: "tri",   fill: "#3EB567", size: 1.8, delay: -1.2, dur: 6,   sway: 6, spin:  1 },
  { x: 64, shape: "circ",  fill: "#FF2D95", size: 1.3, delay: -2.2, dur: 8,   sway: 3, spin: -1 },
  { x: 70, shape: "rect",  fill: "#00E5FF", size: 1.9, delay: -0.6, dur: 7,   sway: 5, spin:  1 },
  { x: 76, shape: "strip", fill: "#FF8F47", size: 1.6, delay: -3,   dur: 9,   sway: 2, spin: -1 },
  { x: 82, shape: "tri",   fill: "#FFEE00", size: 1.4, delay: -1.5, dur: 6,   sway: 4, spin:  1 },
  { x: 88, shape: "circ",  fill: "#8B5CF6", size: 1.1, delay: -0.9, dur: 5,   sway: 6, spin: -1 },
  { x: 94, shape: "rect",  fill: "#FF4D7E", size: 1.7, delay: -2.8, dur: 8.5, sway: 3, spin:  1 },
  { x:  7, shape: "circ",  fill: "#FFEE00", size: 0.8, delay: -3.5, dur: 4.5, sway: 2, spin: -1 },
  { x: 19, shape: "tri",   fill: "#3EB567", size: 0.9, delay: -0.4, dur: 4,   sway: 3, spin:  1 },
  { x: 31, shape: "rect",  fill: "#FFFFFF", size: 1.0, delay: -1.8, dur: 5,   sway: 2, spin: -1 },
  { x: 43, shape: "circ",  fill: "#FF2D95", size: 0.7, delay: -2.6, dur: 4.5, sway: 4, spin:  1 },
  { x: 55, shape: "tri",   fill: "#8B5CF6", size: 0.9, delay: -0.5, dur: 5,   sway: 3, spin: -1 },
  { x: 67, shape: "rect",  fill: "#00E5FF", size: 1.0, delay: -1.4, dur: 4,   sway: 2, spin:  1 },
  { x: 79, shape: "circ",  fill: "#FF8F47", size: 0.8, delay: -3.2, dur: 4.5, sway: 3, spin: -1 },
  { x: 91, shape: "tri",   fill: "#FFFFFF", size: 1.0, delay: -0.7, dur: 5,   sway: 4, spin:  1 },
];

const Shape = ({ shape, fill, size }) => {
  if (shape === "rect") {
    return <rect x={-1.25 * size} y={-0.5 * size} width={2.5 * size} height={1 * size} fill={fill} />;
  }
  if (shape === "strip") {
    return <rect x={-0.35 * size} y={-2 * size} width={0.7 * size} height={4 * size} fill={fill} />;
  }
  if (shape === "tri") {
    return <polygon points={`${-size},${size} ${size},${size} 0,${-size}`} fill={fill} />;
  }
  return <circle cx="0" cy="0" r={size} fill={fill} />;
};

const Piece = ({ p }) => (
  <g transform={`translate(${p.x}, 0)`}>
    <g
      className="confetti"
      style={{
        "--sway": `${p.sway}px`,
        "--spin": p.spin,
        animationDelay: `${p.delay}s`,
        animationDuration: `${p.dur}s`,
      }}
    >
      <Shape shape={p.shape} fill={p.fill} size={p.size} />
    </g>
  </g>
);

const windA = PIECES.filter((_, i) => i % 3 === 0);
const windB = PIECES.filter((_, i) => i % 3 === 1);
const still = PIECES.filter((_, i) => i % 3 === 2);

export const ConfettiBackground = ({ bgColor = "#3E8DFF" }) => (
  <div className="absolute w-full h-full overflow-hidden">
    <svg
      preserveAspectRatio="xMidYMid slice"
      className="w-full h-full"
      viewBox="0 0 100 100"
      style={{ backgroundColor: bgColor }}
    >
      <defs>
        <style>{`
          @keyframes confettiFall {
            0%   { transform: translate(0, -10px)                        rotate(0deg); }
            25%  { transform: translate(var(--sway), 20px)               rotate(calc(var(--spin) * 180deg)); }
            50%  { transform: translate(calc(var(--sway) * -1), 50px)    rotate(calc(var(--spin) * 360deg)); }
            75%  { transform: translate(var(--sway), 80px)               rotate(calc(var(--spin) * 540deg)); }
            100% { transform: translate(calc(var(--sway) * -0.5), 112px) rotate(calc(var(--spin) * 720deg)); }
          }
          @keyframes windA {
            0%,12%    { transform: translateX(0); }
            22%       { transform: translateX(6px); }
            32%,42%   { transform: translateX(10px); }
            52%       { transform: translateX(2px); }
            62%       { transform: translateX(0); }
            100%      { transform: translateX(0); }
          }
          @keyframes windB {
            0%,18%    { transform: translateX(0); }
            28%       { transform: translateX(-7px); }
            38%,48%   { transform: translateX(-11px); }
            60%       { transform: translateX(-3px); }
            72%       { transform: translateX(0); }
            100%      { transform: translateX(0); }
          }
          .confetti {
            animation: confettiFall linear infinite;
            transform-origin: center;
            transform-box: fill-box;
          }
          .wind-a { animation: windA 26s ease-in-out infinite; }
          .wind-b { animation: windB 34s ease-in-out infinite -12s; }
        `}</style>
      </defs>

      <g className="wind-a">
        {windA.map((p, i) => <Piece key={`a-${i}`} p={p} />)}
      </g>
      <g className="wind-b">
        {windB.map((p, i) => <Piece key={`b-${i}`} p={p} />)}
      </g>
      {still.map((p, i) => <Piece key={`s-${i}`} p={p} />)}
    </svg>
  </div>
);
